/* tslint:disable */
/* eslint-disable */
export enum IncomeType {
  None = 'None',
  WageSalary = 'WageSalary',
  Ird = 'Ird',
  Acc = 'Acc',
  Boarder = 'Boarder',
  Superannuation = 'Superannuation',
  RentalIncome = 'RentalIncome',
  SelfEmploymentIncome = 'SelfEmploymentIncome',
  ChildSupport = 'ChildSupport',
  Msd = 'Msd',
  Other = 'Other'
}
